import { addNavMenuSection } from '@vendure/admin-ui/core';

export default [
    addNavMenuSection(
        {
            id: 'suggested-orders-group',
            label: 'Pedidos Sugeridos',
            icon: 'folder',
            items: [
                {
                    id: 'suggested-orders',
                    label: 'Pedidos sugeridos',
                    routerLink: ['/extensions/suggested-orders'],
                    icon: 'lightbulb',
                },
                {
                    id: 'merge-audit-logs',
                    label: 'Merge Audit Logs',
                    routerLink: ['/extensions/merge-audit-logs'],
                    icon: 'list',
                    requiresPermission: (userPermissions) =>
                        userPermissions.includes('ReadCatalog'),
                },
            ],
        },
        'marketing'
    ),
];
